import { render, staticRenderFns } from "./AppointmentDetailsModal.vue?vue&type=template&id=05fc882b&scoped=true&"
import script from "./AppointmentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetailsModal.vue?vue&type=style&index=0&id=05fc882b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc882b",
  null
  
)

export default component.exports